import PropTypes from "prop-types";
import "./ContractRemarks.scss";
import Collapse from "app/components/ui/collapse/Collapse";
import { FormattedMessage } from "react-intl";
import { htmlSanitize } from "app/utils/sanitize";
import { useCallback, useState } from "react";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import IconArrowDown from "app/pages/.shared/static/icons/IconArrowDown";

const ContractRemarks = ({ remarks }) => {
	const { track } = useAnalytics();
	const [isCollapseOpen, setIsCollapseOpen] = useState(false);

	const handleCollapseClick = useCallback(() => {
		if (!isCollapseOpen) {
			track("open_remarks_section");
		}
		setIsCollapseOpen(!isCollapseOpen);
	}, [isCollapseOpen]);

	return remarks ? (
		<Collapse
			expandIcon={({ isActive }) => {
				return (
					<IconArrowDown
						style={{
							transition: "transform .2s ease",
							transform: `rotate(${isActive ? 180 : 0}deg)`,
						}}
					/>
				);
			}}
			onChange={handleCollapseClick}
		>
			<Collapse.Panel
				headerClass="booking-useful-information__header"
				header={
					<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} isBold>
						<FormattedMessage id="booking.additional.informations" />
					</Typography>
				}
			>
				<div className="remarks__content">
					<section
						className="remarks__content-text"
						dangerouslySetInnerHTML={{ __html: htmlSanitize(remarks) }}
					/>
				</div>
			</Collapse.Panel>
		</Collapse>
	) : null;
};

ContractRemarks.propTypes = {
	remarks: PropTypes.string,
};

export default ContractRemarks;
